import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import lodfilter  from 'lodash-es/filter';
import { Subscription } from 'rxjs';
import { HomePageContainerService } from '../home-page/home-page-container.service';
import { ScreenUpdateService } from '../home-page/home-page-screens-updates/screen-update.service';
import { ScreenDetailsModel } from '../home-page/screen-details/screen-details-model';
import { GtwElementsBaseUrlsModel } from '../shared/_models/gtw-elements-base-urls.model';
import { ActiveScreensService } from '../shared/_services/active-screens.service';
import { WorkspaceService } from '../workspace/workspace.service';
import { GlobalService } from '../global/services/global.service';
import { HeaderService } from './header.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AvatarComponent } from '@appkit4/angular-components/avatar';

import { safeJsonInput } from '../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HeaderComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

	@Output('load-modules') loadModules = new EventEmitter<any>();
	@Output('load-client') loadClient = new EventEmitter<any>();
	@Output('change-theme') changeTheme = new EventEmitter<any>();
	@Output('set-taxYearScenario') setTaxYearScenario = new EventEmitter<any>();
	@Output('set-scenario') setScenario = new EventEmitter<any>();
	@Output('set-businesses') setBusinesses = new EventEmitter<any>();
	@Output('sync-businesses') syncBusinesses = new EventEmitter<any>();
	@Output('global-params-changed') globalParamsChanged = new EventEmitter<any>();
	@Output('got-notifications') gotNotifications = new EventEmitter<any>();
	@Output('load-application') loadApplication = new EventEmitter<any>();
	@Output('load-screens') loadScreen =  new EventEmitter<{activity_key?:string, screen_key?:string}>();
	@Output('set-issue') setIssue = new EventEmitter<any>();
  @Output('logout-user') logoutUser = new EventEmitter<any>();

	@ViewChild(AvatarComponent) avatarComponent?: AvatarComponent;

	baseURLs: any={};

	isDarkTheme: boolean = true;
	@Input('is-dark-theme')
	set _isDarkTheme(val:string){
		if('theme-black' == val ){
			this.isDarkTheme = true;
		}else{
			this.isDarkTheme=false;
		}
	}

	globalService : any;
	@Input('base-urls')
	set _base_urls(baseUrls: string){
		try{
			let urls:GtwElementsBaseUrlsModel = safeJsonInput<any>(baseUrls, null, 'header.parse1');
			if(Object.keys(urls).length > 0){
				this.baseURLs = urls;
			}
		}catch(e){
			console.log("Input Not yet stable. Still waiting to get resolved.");
		}
	}

	breadCrumbLink: string[] = [];
	@Input('bread-crumb')
	set _bread_crumb(keys : any){
		try{
		this.breadCrumbLink = safeJsonInput<any>(keys, null, 'header.parse2');
		}catch(error){
		console.log("Not an valid object");
		}
	}

	clientList : any[] = [];
	clientDropdownItems: any[] = [];
	selectedClientName = '';

	applicationList : any[] = [];

	taxYearList : any[] = [];

	scenarioList : any[] = [];

	issuesList : any[] = [];
	isIssueListLoaded = false;

	taxYearListTemp : any[] = [];

	scenarioListTemp : any[] = [];

	USER_SETTINGS : any = {};
	SERVER_CONFIG : any = {};
	GENERAL_CONFIG : any = {};

	businessMeData : any = [];

	selectedApplication = '';
	selectedApplicationKey = 0;
	selectedTaxYear = '';
	selectedScenario : any = {};

	selectedApplicationItem: any = {};
	selectedTaxYearItem: any = {};
	selectedScenarioItem: any = {};
	selectedIssueItem: any = {};
	selectedClientItem: any = {};

	applicationDropdownItems: any[] = [];
	taxYearDropdownItems: any[] = [];
	scenarioDropdownItems: any[] = [];
	issuesDropdownItems: any[] = [];

	menuObj1 : any = [];
	childMenuObj : any = [];
	totalSelected = 0;
	selected : any = [];
	selectedArray : any  = [];
	showMenu = false;
	showRightMenu = false;
	filterss :any = [];
	public dropdownMenuActive = "";
	public showDropdownMenu = false;
	public logoutMenu = false;
	public navTogglerDiv = false;
	showBusinessMenu = false;
	showNotificationsPanel = false;
	showSubBusinessMenu = false;
	showFavPanel = false;
	isNotifPanel = false
	subBusinessMeData : any = []

	public search = false;
	public appList = false;
	public name = 'GTW';
	public selectionCursor = -1;
	client_logo = '';
	logo_client = '';
	user_logo = '';
	display_name = '';
	userInitials = '';
	singleMeGrpCount = 0;
	totalMeSelected = 0;
	tempTotalMeSelected = 0;
	oldScenarioTypeCode = '';
	messageCount: string = '0';
	clientKey?:number

	isFavLoaded = true;
	favScreens: any[] = [];
	allScreens!: ScreenDetailsModel[];

	@Input('header-data')
	set headerData(headerData : any){
		try{
			this.clientList = [];
			this.applicationList = [];
			this.taxYearList = [];
			this.scenarioList = [];

			this.taxYearListTemp = [];
			this.scenarioListTemp = [];
			this.issuesList = [];
			this.isIssueListLoaded = false;

			this.globalService = safeJsonInput<any>(headerData, null, 'header.parse3');

			let globalParams = this.globalService.globalParams;
			let clientData = this.globalService.clientData;
			let channelData = this.globalService.channelData;
			let taxYearData = this.globalService.taxYearScenarioData;
			this.USER_SETTINGS = this.globalService.userSettingsData;
			this.SERVER_CONFIG = this.globalService.serverConfigData;
			this.GENERAL_CONFIG = this.globalService.generalConfigData;
			this.user_logo = this.globalService.userSettingsData.user.avatar_path;
			this.display_name = this.globalService.userSettingsData.user.short;
			this.userInitials = this.getInitials(this.display_name);

			//Iterate over Tax Year's Array and modify the object as per the appkit selector required object
			this.client_logo = clientData.client.client_logo;
			this.logo_client = this.baseURLs.admin +'/downloadClientLogo/'+clientData.client.client_key
			this.clientKey = clientData.client.client_key;
			this.selectedClientName = clientData?.client?.client_name || '';
			clientData.clients.forEach( (client : any) => {
				let tempClientData = Object.assign({}, client)
				tempClientData.label = client.client_name;
				tempClientData.value = client.client_key;
				tempClientData.selected = client.client_key === this.clientKey;
				this.clientList.push(tempClientData);
			});
		this.clientDropdownItems = this.getDropdownItems(this.clientList, 'Client');
		const selectedClient = this.clientDropdownItems.find((c: any) => c.selected);
		this.selectedClientItem = selectedClient || this.clientDropdownItems[0] || {};

		//Application Data as per the appkit selector required object
		this.applicationList = channelData;
		this.applicationList.forEach( (channel : any) => {
			if(channel.selected){
				this.selectedApplication = this.resolveDropdownText(channel);
				this.selectedApplicationKey = channel.value;
			}
		});
		if (!this.selectedApplication && this.applicationList.length > 0) {
			this.selectedApplication = this.resolveDropdownText(this.applicationList[0]);
			this.selectedApplicationKey = this.applicationList[0].value || 0;
			this.applicationList[0].selected = true;
		}
		this.headerService.setChannel(this.selectedApplicationKey);
		this.syncDropdownSelections();

		//Iterate over Tax Year's Array and modify the object as per the appkit selector required object
			this.unwrapDropdownListData(taxYearData.values).forEach( (taxYear : any) => {
				let counter = 0;
				let tempTaxYear = Object.assign({}, taxYear)
				tempTaxYear.label = taxYear.label;
				tempTaxYear.selected = false;

				if(taxYear.value === this.globalService.taxYearScenarioData.selected.value){
					let taxYearObj = Object.assign({}, taxYear);
					taxYearObj.channel_key = this.selectedApplicationKey;
					tempTaxYear.selected = true;
					this.selectedTaxYear = taxYear.value;

					//Iterate over Scenario's Array and modify the object as per the appkit selector required object
					taxYear.scenarios.forEach( (scenario : any) => {
						let tempScenario = Object.assign({}, scenario)
						tempScenario.label = scenario.scenario_desc;
						tempScenario.selected = false;
						if(scenario.scenario === this.globalService.taxYearScenarioData.selected.scenario){
							tempScenario.selected = true;
							this.selectedScenario = tempScenario;
						};
						if(this.selectedApplicationKey == scenario.channel_key){
							//counter ++;
							this.scenarioList.push(tempScenario);
						}
					});
					this.taxYearList.push(tempTaxYear);
					taxYearObj.scenarios = this.scenarioList;
					this.setTaxYearScenario.emit(taxYearObj);
				}else{
					taxYear.scenarios.forEach( (scenario : any) => {
						if(this.selectedApplicationKey == scenario.channel_key){
							counter ++;
						}
					});
				}
				if(counter > 0){
					this.taxYearList.push(tempTaxYear);
				}

			});
			this.taxYearListTemp = this.taxYearList.slice();
			if (!this.selectedTaxYear && this.taxYearList.length > 0) {
				this.taxYearList[0].selected = true;
				this.selectedTaxYear = this.taxYearList[0].value;
			}
		if (!this.selectedScenario?.scenario && this.scenarioList.length > 0) {
			this.scenarioList[0].selected = true;
			this.selectedScenario = this.scenarioList[0];
		}
		this.syncDropdownSelections();
		this.leftNavSelectedMe(this.baseURLs.api, this.selectedTaxYear, this.selectedScenario.scenario, this.selectedScenario.jcd_key);
			this.getAllScreens();
			this.getUnreadMessages();
			this.init();
		}catch(e){
			console.log("Input Not yet stable. Still waiting to get resolved.");
		}
	}

	public dropdownMenuData = [
		{ title: 'Channel/Tax Year/BE', content: 'Starbucks', active: true },
		{ title: 'Page menu one', content: 'Starbucks', active: false },
		{ title: 'Page menu two', content: 'Starbucks', active: false },
		{ title: 'Page menu three', content: 'Starbucks', active: false },
	];

	public avatarDropdownList = [
		// { label: 'Lock Screen', value: 'settings', iconName: 'lockclosed-locked-outline' },
		// { label: 'My Settings', value: 'settings', iconName: 'setting-outline' },
		{ label: 'Admin Settings', value: 'admin.users-list', iconName: 'setting-outline' },
		// { label: 'Access Request', value: 'userSettings.user-access-request', iconName: 'person-outline' }
	];

	private breadcrumbSub?: Subscription;
	private favScreensSub?: Subscription;
	private globalParamsSub?: Subscription;

	constructor(private headerService : HeaderService,
		 		private homePageContainerService: HomePageContainerService,
				private activeScreensService:ActiveScreensService,
				private screenUpdateService:ScreenUpdateService,
				private workspaceService: WorkspaceService,
				private gtwGlobalService: GlobalService,
				private changeDetectorRef: ChangeDetectorRef,
				private elRef: ElementRef) { }

	ngOnInit(): void {
		const dom = document.body;
		dom.setAttribute('data-theme-logo',getComputedStyle(document.documentElement).getPropertyValue('--theme-color-logo').trim());
		this.dropdownMenuData.some(res => {
		if (res.active) {
			this.dropdownMenuActive = res.title;
		}
		return res.active
		});
		this.init();
	}

	hideLogoOnError(event: Event): void {
		const target = event.target;
		if (target && target instanceof HTMLElement) {
			target.style.display = 'none';
		}
	}

	init(){
		this.favScreens = [];
		this.isFavLoaded = false;

		// `init()` is invoked from `ngOnInit` AND again from `_tax_year` /
		// `_scenario` setters once the host CE inputs stabilise, so guard the
		// long-lived `BehaviorSubject` subscription against duplicate stacking
		// and tear it down explicitly on destroy.
		if (!this.favScreensSub) {
			this.favScreensSub = this.screenUpdateService.allFavScreens$.subscribe((favScreens: any) => {
				if(favScreens && favScreens.length > 0) {
					this.favScreens = favScreens;
					this.changeDetectorRef.detectChanges();
				} else {
					this.favScreens = [{SCREEN_NAME:'No screen selected as favorite'}];
				}
			});
		}

		// The tax year can be advanced from a screen's own filter bar
		// (`DataFiltersComponent.syncTaxYearToGlobalAndReload`), which writes the
		// canonical `GlobalService` state and fires `globalParamsChanged$`. The
		// header keeps its OWN copy of the selection, so without this listener the
		// toolbar keeps showing the startup year (e.g. 2025) while the active
		// screen already reflects the new one (e.g. 2024). Mirror global -> header
		// display only; never re-emit (see reflectGlobalTaxYearFromGlobal).
		if (!this.globalParamsSub) {
			this.globalParamsSub = this.gtwGlobalService.globalParamsChanged$.subscribe(() => {
				this.reflectGlobalTaxYearFromGlobal();
			});
		}

		if (!this.breadcrumbSub) {
			this.breadcrumbSub = this.workspaceService.setTabActive.subscribe((screen: any) => {
				if (screen && screen.label) {
					this.breadCrumbLink = this.buildBreadcrumb(screen);
				} else {
					this.breadCrumbLink = ['Home'];
				}
				this.changeDetectorRef.detectChanges();
			});
		}
	}

	ngOnDestroy(): void {
		this.breadcrumbSub?.unsubscribe();
		this.favScreensSub?.unsubscribe();
		this.globalParamsSub?.unsubscribe();
	}

	/**
	 * Keep the toolbar tax-year (and its scenario) in sync with the canonical
	 * `GlobalService` state when the year is changed from somewhere other than
	 * the header itself (e.g. a screen's filter bar). This is DISPLAY ONLY:
	 *
	 *  - It never emits `setTaxYearScenario` / `globalParamsChanged`, so it
	 *    cannot loop back through `AppComponent` -> `globalParamsChanged$`.
	 *  - It is gated on the YEAR actually differing. Header-originated changes
	 *    (`taxYearSelection`) have already set `selectedTaxYear` before the event
	 *    propagates here, so they short-circuit and leave the scenario the user
	 *    just picked untouched.
	 */
	private reflectGlobalTaxYearFromGlobal(): void {
		const gas = this.gtwGlobalService?.global?.inputs?.tax_year?.selected;
		if (!gas) {
			return;
		}

		const wantYear = String(gas.value ?? '');
		if (!wantYear || String(this.selectedTaxYear) === wantYear) {
			return;
		}

		const matchYear = (this.taxYearList || []).find(
			(ty: any) => String(ty?.value) === wantYear
		);
		if (!matchYear) {
			return;
		}

		this.selectedTaxYear = matchYear.value;
		this.markSelectedByValue(this.taxYearList || [], this.selectedTaxYear);

		// Rebuild the scenario list for the resolved year, scoped to the current
		// channel — mirrors the relevant slice of `taxYearSelection`, minus emits.
		this.scenarioList = [];
		(matchYear.scenarios || []).forEach((scenario: any) => {
			if (this.selectedApplicationKey == scenario.channel_key) {
				const tempScenario = Object.assign({}, scenario);
				tempScenario.label = scenario.scenario_desc;
				tempScenario.selected = false;
				this.scenarioList.push(tempScenario);
			}
		});

		const wantScenario = String(
			gas.scenario ?? this.gtwGlobalService?.global?.globalParams?.scenario ?? ''
		);
		const chosenScenario =
			this.scenarioList.find((s: any) => String(s.scenario) === wantScenario) ||
			this.scenarioList.find((s: any) => s.default_scenario === 'Y') ||
			this.scenarioList[0];
		if (chosenScenario) {
			this.selectedScenario = chosenScenario;
			this.markSelectedByValue(
				this.scenarioList || [],
				this.selectedScenario?.value ?? this.selectedScenario?.scenario
			);
		}

		this.syncDropdownSelections();
		this.changeDetectorRef.detectChanges();
	}

	private buildBreadcrumb(screen: any): string[] {
		// Pre-built path (e.g. /admin/* screens not registered in USER_MENU).
		if (screen?.breadcrumbLabels?.length) {
			return screen.breadcrumbLabels;
		}
		// Use a stateless DFS over USER_MENU to collect the full ancestor chain
		// for the screen's link. This avoids any dependency on the `parent`
		// property that `findScreenByLink` mutates onto nodes — that mutation
		// strategy is order-sensitive and breaks on browser reload when an earlier
		// call's DFS stops before visiting the current screen's ancestors.
		if (screen?.link) {
			const path = this.workspaceService.findBreadcrumbPath(screen.link);
			if (path.length) {
				return path;
			}
		}
		// Fallback for synthetic screens (CE-only, home marker, etc.) that have
		// no link registered in USER_MENU — just show whatever label is set.
		return screen?.label ? [screen.label] : [];
	}

	getInitials(name : string){
		let names = name.split(' ')
		let initials = names[0].substring(0, 1).toUpperCase();

		if (names.length > 1) {
			initials += names[names.length - 1].substring(0, 1).toUpperCase();
		}
		return initials;
	}

	onDrop(event: CdkDragDrop<any[]>) {
		if (event.previousContainer === event.container) {
			moveItemInArray(this.favScreens, event.previousIndex, event.currentIndex);
			this.screenUpdateService.allFavScreens$.next(this.favScreens);

			this.changeDetectorRef.detectChanges();

			console.log('this.favScreens',this.favScreens);
		} else {
			transferArrayItem(event.previousContainer.data,
				event.container.data,
				event.previousIndex,
				event.currentIndex);
		}

	 }

	getAllScreens() {
		this.homePageContainerService.getAllScreens(this.baseURLs.api,this.USER_SETTINGS.user.client_key).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
			this.allScreens = data;
			this.homePageContainerService.screenList = this.allScreens;
		});
	}

	changeClient(client: any){
		const normalizedClient = this.normalizeDropdownEvent(client);
		const selectedClient = normalizedClient?.selected?.[0];
		if (selectedClient) {
			this.selectedClientName = selectedClient.client_name || selectedClient.text || '-';
		}
		this.loadClient.emit(normalizedClient);
	}

	channelSelection(channel: any){
		const normalizedChannel = this.normalizeDropdownEvent(channel);
		if (!normalizedChannel.change) {
			return;
		}

		this.taxYearList = [];
		let tempObj : any = [];

		this.selectedApplication = this.resolveDropdownText(normalizedChannel.change);
		this.selectedApplicationKey = normalizedChannel.change.value;
		this.selectedApplicationItem = normalizedChannel.change;
		this.markSelectedByValue(this.applicationList || [], this.selectedApplicationKey);
		this.taxYearListTemp.forEach( (taxYear : any) => {
			let counter = 0;
			taxYear.scenarios.forEach( (scenario : any) => {
				if(this.selectedApplicationKey == scenario.channel_key){
					counter ++;
				};
			});
			if(counter > 0){
				tempObj.push(taxYear);
			};
		});
		this.headerService.setChannel(this.selectedApplicationKey);
		tempObj[0].selected = true;
		this.taxYearList = tempObj;
		let appKitSelectedObject = {
			change : this.taxYearList[0],
			items : this.taxYearListTemp,
			selected : [this.taxYearList[0]]
		}
		this.taxYearSelection(appKitSelectedObject);
		this.loadApplication.emit(normalizedChannel.change);
	}

	taxYearSelection(taxYear: any){
		const normalizedTaxYear = this.normalizeDropdownEvent(taxYear);
		if (!normalizedTaxYear.selected[0]) {
			return;
		}

		let taxYearObj = Object.assign({}, normalizedTaxYear.selected[0]);
		taxYearObj.channel_key = this.selectedApplicationKey;
		// Keep a flat list of scenario items for AppKit dropdown binding.
		// Using a placeholder object here can get selected and prevents UI from
		// reflecting the actual chosen scenario.
		this.scenarioList = [];
		this.selectedTaxYear = normalizedTaxYear.selected[0].value;
		this.selectedTaxYearItem = normalizedTaxYear.selected[0];
		// taxYearList is a flat AppKit list in this component; marking [0].data leaves
		// selected flags stale and causes dropdown UI to snap back to previous value.
		this.markSelectedByValue(this.taxYearList || [], this.selectedTaxYear);

		//this.setTaxYearScenario.emit(taxYear.change);

		let defaultCheckcounter = 0;

		normalizedTaxYear.selected[0].scenarios.forEach( (scenario : any) => {
			let tempScenario = Object.assign({}, scenario)
			tempScenario.label = scenario.scenario_desc;
			tempScenario.selected = false;

			if(this.selectedApplicationKey == tempScenario.channel_key){
				//counter ++;
				this.scenarioList.push(tempScenario);
			}
		});

		taxYearObj.scenarios = this.scenarioList;

		this.scenarioList.forEach( (scenario : any) => {
			if(scenario.default_scenario === 'Y'){
				scenario.selected = true;
				this.selectedScenario = scenario;
				defaultCheckcounter ++;
			};
		})

		if(defaultCheckcounter == 0 && this.scenarioList.length > 0){
			this.scenarioList[0].selected = true;
			this.selectedScenario = this.scenarioList[0];
		}
		this.markSelectedByValue(this.scenarioList || [], this.selectedScenario?.value ?? this.selectedScenario?.scenario);
		this.syncDropdownSelections();

		// taxYearObj.scenario = this.selectedScenario.scenario;
		// taxYearObj.scenario_desc = this.selectedScenario.scenario_desc;
		// taxYearObj.scenario_type_code = this.selectedScenario.scenario_type_code;

		//Set selected tax year and scenario values.
		this.setTaxYearScenario.emit(taxYearObj);

		let defaultScenario : any = lodfilter(this.scenarioList, {
			default_scenario: 'Y'
		});

		if (null != defaultScenario && defaultScenario != 'undefined' && defaultScenario.length > 0) {
			this.scenarioSelection(defaultScenario[0], false);
		}else{
			this.globalParamsChanged.emit();
			if (this.scenarioList.length > 0) {
				this.scenarioSelection(this.scenarioList[0], false);
			}
		}
		//this.leftNavSelectedMe(this.baseURLs.api, taxYear.selected[0].value, taxYear.selected[0].scenario, this.scenarioList[0]?.jcd_key); // used to get heirarchy list based on the tax year selection
	}

	scenarioSelection(_selectedScenario : any, isMain : boolean) {
		//let selectedScenario : any = {};
		this.selectedScenario = {};
		let globalAppParams = {
			channel : this.selectedApplicationKey,
			taxYear : this.selectedTaxYear,
			scenarioKey : '',
			scenarioCode : '',
			scenario_desc : ''
		}
		this.reset();
		if(isMain){
			const normalizedScenario = this.normalizeDropdownEvent(_selectedScenario);
			if (!normalizedScenario.selected[0]) {
				return;
			}
			globalAppParams.scenarioKey = normalizedScenario.selected[0].scenario;
			globalAppParams.scenarioCode = normalizedScenario.selected[0].scenario_type_code;
			globalAppParams.scenario_desc = normalizedScenario.selected[0].scenario_desc;
		///	this.setScenario.emit(globalAppParams);
			this.selectedScenario = normalizedScenario.selected[0];
			//this.selectedScenario = _selectedScenario.selected[0];
		}else{
			globalAppParams.scenarioKey = _selectedScenario.scenario;
			globalAppParams.scenarioCode = _selectedScenario.scenario_type_code;
			globalAppParams.scenario_desc = _selectedScenario.scenario_desc;
		//	this.setScenario.emit(globalAppParams);
			this.selectedScenario = _selectedScenario;
			//this.selectedScenario = _selectedScenario;
		}

		this.taxYearList.forEach( (tax_year : any) => {
			if(tax_year.selected){
				// vm.tax_year.selected.scenario_desc = _selectedScenario.scenario_desc;
				// vm.tax_year.selected.scenario = _selectedScenario.scenario;
				tax_year.scenario_desc = this.selectedScenario.scenario_desc;
				tax_year.scenario = this.selectedScenario.scenario;
				tax_year.scenario_type_code = this.selectedScenario.scenario_type_code;
			}
		});

		this.selectedScenarioItem = this.selectedScenario;
		this.markSelectedByValue(this.scenarioList || [], this.selectedScenario?.value ?? this.selectedScenario?.scenario);
		this.setScenario.emit({globalAppParams:globalAppParams,taxYearList: this.taxYearList});
		this.getIssues();

		if(this.oldScenarioTypeCode.length === 0 || (this.oldScenarioTypeCode.length > 0 && this.oldScenarioTypeCode !== this.selectedScenario.scenario_type_code)) {
			//this.getUserMenu();
			this.oldScenarioTypeCode = this.selectedScenario.scenario_type_code ? this.selectedScenario.scenario_type_code : '';
		}

		this.globalParamsChanged.emit();
		this.leftNavSelectedMe(this.baseURLs.api, this.selectedTaxYear, this.selectedScenario.scenario, this.selectedScenario.jcd_key);
	}

	issueSelection(_selectedIssue : any){
		const normalizedIssue = this.normalizeDropdownEvent(_selectedIssue);
		const selectedIssue = normalizedIssue.selected[0];
		this.selectedIssueItem = selectedIssue || {};
		this.markSelectedByValue(this.issuesList || [], selectedIssue?.value ?? selectedIssue?.issue_key ?? selectedIssue?.ISSUE_KEY);
		let issueData = {
			data : {},
			selectedIssueData : selectedIssue,
			setAllParams : false,
			setOnlyId : true,
			emptyIssue : true
		};
		this.setIssue.emit(issueData);
	};

	/** Unwraps legacy selector shape `[{ data: [...] }]` to a flat array. */
	private unwrapDropdownListData(source: any): any[] {
		if (source == null) {
			return [];
		}
		if (Array.isArray(source) && source.length === 1 && Array.isArray(source[0]?.data)) {
			return source[0].data;
		}
		return Array.isArray(source) ? source : [];
	}

	/** Normalizes flat `{ value, label }` items for Appkit4 dropdowns (maps API `text` to `label` when needed). */
	getDropdownItems(items: any, contextLabel: string = 'Option'): any[] {
		const list = this.unwrapDropdownListData(items);

		return list
			.filter((item: any) => item !== null && item !== undefined)
			.map((item: any) => {
				const resolvedText = this.resolveDropdownText(item);
				const resolvedValue = item?.value ?? item?.scenario ?? item?.issue_key ?? item?.ISSUE_KEY ?? item?.client_key ?? item?.id ?? resolvedText;
				const label = String(item?.label ?? item?.text ?? resolvedText).trim() || resolvedText;
				const ariaLabel = this.setAriaLabel({ ...item, label }, contextLabel);
				return {
					...item,
					label,
					value: resolvedValue,
					ariaLabel
				};
			})
			.filter((item: any) => {
				const label = String(item?.label ?? '').trim().toLowerCase();
				return label !== '' && label !== 'undefined' && label !== 'null';
			});
	}

	private resolveDropdownText(item: any): string {
		const candidates = [
			item?.text,
			item?.TEXT,
			item?.label,
			item?.LABEL,
			item?.name,
			item?.NAME,
			item?.screenName,
			item?.SCREEN_NAME,
			item?.screen_desc,
			item?.SCREEN_DESC,
			item?.scenario_desc,
			item?.SCENARIO_DESC,
			item?.issue_short_desc,
			item?.ISSUE_SHORT_DESC,
			item?.client_name,
			item?.CLIENT_NAME,
			item?.channel_desc,
			item?.CHANNEL_DESC,
			item?.tax_year,
			item?.TAX_YEAR,
			item?.value
		];

		for (const value of candidates) {
			if (value !== null && value !== undefined) {
				const text = String(value).trim();
				if (text && text.toLowerCase() !== 'undefined' && text.toLowerCase() !== 'null') {
					return text;
				}
			}
		}
		return '-';
	}

	onDropdownSelectItem(event: any): void {
		console.log(event);
	}

	private markSelectedByValue(list: any[], selectedValue: any): void {
		if (!Array.isArray(list)) {
			return;
		}
		list.forEach((item: any) => {
			const itemValue = item?.value ?? item?.scenario ?? item?.issue_key ?? item?.ISSUE_KEY;
			item.selected = String(itemValue) === String(selectedValue);
		});
	}

	setAriaLabel(item: any, contextLabel: string = 'Option'): string {
		const prefixLabel = item?.iconName ? `Icon ${item.iconName}, ` : '';
		const label = item?.label || item?.text || '-';
		const badgeLabel = item?.badgeValue ? `, Badge ${item.badgeValue}` : '';
		const suffixLabel = item?.descValue ? `, ${item.descValue}` : '';
		return `${contextLabel} option ${prefixLabel}${label}${badgeLabel}${suffixLabel}`.trim();
	}

	syncDropdownSelections(): void {
		this.applicationDropdownItems = this.getDropdownItems(this.applicationList, 'Application');
		const selectedApp = this.applicationDropdownItems.find((i: any) => i.selected);
		this.selectedApplicationItem = selectedApp || this.applicationDropdownItems[0] || {};

		this.taxYearDropdownItems = this.getDropdownItems(this.taxYearList, 'Tax Year');
		const selectedTy = this.taxYearDropdownItems.find((i: any) => i.selected);
		this.selectedTaxYearItem = selectedTy || this.taxYearDropdownItems[0] || {};

		this.scenarioDropdownItems = this.getDropdownItems(this.scenarioList, 'Scenario');
		const selectedSc = this.scenarioDropdownItems.find((i: any) => i.selected);
		this.selectedScenarioItem = selectedSc || this.scenarioDropdownItems[0] || {};

		if (this.isIssueListLoaded) {
			this.issuesDropdownItems = this.getDropdownItems(this.issuesList, 'Issue Id');
			const selectedIss = this.issuesDropdownItems.find((i: any) => i.selected);
			this.selectedIssueItem = selectedIss || this.issuesDropdownItems[0] || {};
		} else {
			this.issuesDropdownItems = [];
			this.selectedIssueItem = {};
		}
	}

	/**
	 * Normalize AppKit dropdown events to a consistent `{ selected: [], change }` shape.
	 * Supports both legacy and current payloads.
	 */
	private normalizeDropdownEvent(event: any): any {
		if (event && Array.isArray(event.selected) && Object.prototype.hasOwnProperty.call(event, 'change')) {
			return event;
		}

		const selected = Array.isArray(event?.selected)
			? event.selected
			: (event?.selected ? [event.selected] : (event?.change ? [event.change] : (event ? [event] : [])));

		return {
			selected,
			change: selected[0] ?? null,
			originEvent: event?.originEvent || event
		};
	}

	leftNavSelectedMe(url : string, selectedTaxYear : string, selectedScenario : string, jcd_key : any) {
		this.filterss.loading = true;
		this.headerService.getBizHeirarchy(url, selectedTaxYear, selectedScenario, jcd_key).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
			this.filterss.selected = [];
			this.filterss.loading = false;
			this.filterss.values = data.jsonObject;
			this.setBusinesses.emit(this.filterss);
			this.setTreeParent((data.jsonObject),'children' );
			this.menuObj1 = data.jsonObject;
			this.getTotalSelected();
		},
		error => {
			console.log(error);
			// Deciede whether to configure alert here on use the same in the AngularJS App.
			//AlertService.add('error', 'Global level ME seletions list failed, please contact support');
		},() => {
			console.log('Completed all tabs');
		});
	}

	getIssues() {
		this.isIssueListLoaded = false;
		this.headerService.getIssues(this.baseURLs.api, this.selectedTaxYear, this.selectedScenario.scenario).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
			if(data.callSuccess == 1) {
				let issueData = {
					data : {},
					selectedIssueData : '',
					setAllParams : false,
					setOnlyId : false,
					emptyIssue : false
				};
				const issueRows = this.unwrapDropdownListData(data.issue);
				if(issueRows.length > 0){
					let tempIssueList = issueRows;
					tempIssueList.forEach( (issue : any) => {
						issue.label = issue.issue_short_desc;
					});
					tempIssueList[0].selected = true;
					this.issuesList = tempIssueList;

					//Set Issue Data Globally.
					issueData.data = this.issuesList;
					issueData.selectedIssueData = this.issuesList[0];
					issueData.setAllParams = true;
					this.setIssue.emit(issueData);
				}else{
					this.issuesList = [];
					this.setIssue.emit(issueData);
				}
			} else {
				this.issuesList = [];
				console.log('Global level issue id list failed, please contact support');
				//AlertService.add('error', 'Global level issue id list failed, please contact support');
			}
		},
		error => {
			this.issuesList = [];
			console.log(error);
			// Deciede whether to configure alert here on use the same in the AngularJS App.
			//AlertService.add('error', 'Global level ME seletions list failed, please contact support');
	},() => {
		console.log('Completed all tabs');
		this.isIssueListLoaded = true;
		this.syncDropdownSelections();
	});
	};

	setTreeParent(_collection : any,_children : any){
		for (var i = 0; i < _collection.length; i++) {
			var thisChildren =  _collection[i][_children];
			if( thisChildren && thisChildren.length ){
				this.setTreeParent(thisChildren,_children);
			}

			for(var n in thisChildren){
				thisChildren[n].parent = _collection[i];
			}
		}
	}

	reset(){
		this.totalSelected = 0;
		this.menuObj1 = [];
		this.childMenuObj = [];
		this.selected  = [];
		this.selectedArray  = [];
		this.showMenu = false;
		this.showRightMenu = false;
		this.showSubBusinessMenu = false;
		this.filterss.selected = [];
		this.syncBusinesses.emit(this.filterss);
	}

	change() {
		this.createdSelectedArray();
		this.filterss.selected = this.selectedArray;
		this.syncBusinesses.emit(this.filterss);
	}

	createdSelectedArray(){
		this.selectedArray = [];
		for (var i = 0; i < this.selected.length; i++) {
			let newObj :any = {}
			newObj.VALUE = this.selected[i];
			newObj.parnet = this.selected[i];
			newObj.level = this.selected[i];
			this.selectedArray.push(newObj);
		}
	}

	setTreeAttribute(_collection:any,_predicate:any,_children:any,value:any){
		for (var i = 0; i < _collection.length; i++) {
			var  n = _collection[i][_predicate];
			var children = _collection[i][_children];
			if(children && children.length ){
				this.setTreeAttribute(children,_predicate,_children,value );
			}
			_collection[i][_predicate] = value;
		}
	}

	selectParentMe(item:any){
		this.setTreeAttribute(this.menuObj1,'active','children',false);
		item.active = true;
		this.childMenuObj = item.children;
		this.showSubBusinessMenu = true;
	};

	toggleMenu(){
		this.showMenu = !this.showMenu;
		if(!this.showMenu ){
			this.showRightMenu = false;
		}
	}

	selectAll(){
		this.setTreeAttribute(this.menuObj1,'selected','children',true);
		this.getSelectedAll();
		this.change();
	}

	getSelectedAll(){
		this.selected  = [];
		var selected = 0;
		let tempSelectedArray :any = [];

		this.menuObj1.forEach( (item : any) => {
			if(item.selected ){
				selected++;
				//this.selected.push(item.key);
				tempSelectedArray.push(item.key);
			}
			if(item.children && item.children.length > 0) {
				item.numSelected = recursiveSelected(item);
			}
		})

		function recursiveSelected(collection:any){
			var selected = 0;
			function recursiveSelectedInner(collection:any) {
				collection.children.forEach( (item : any) => {
					if(item.selected){
						//this.selected.push(item.key);
						tempSelectedArray.push(item.key);
						selected++;
					}
					if(item.children && item.children.length > 0) {
						recursiveSelectedInner(item);
					}
				});
			}
			recursiveSelectedInner(collection)
			return selected;
		}
		this.selected = tempSelectedArray;
		return selected;

	}

	unselectAll(){
		this.setTreeAttribute(this.menuObj1,'selected','children',false);
		this.getSelected();
		this.change();
	}

	getSelected(){
		this.selected  = [];
		let selected = 0;
		let tempSelectedArray :any = [];

		this.menuObj1.forEach( (item : any) => {
			if(item.selected ){
				selected++;
				//this.selected.push(item.key);
				tempSelectedArray.push(item.key);
			}
			if(item.children && item.children.length > 0) {
				item.numSelected = recursiveSelected(item);
			}
		})

		function recursiveSelected(collection : any){
			var selected = 0;
			function recursiveSelectedInner(collection : any) {
				collection.children.forEach( (item : any) => {
					if(item.selected ){
						//this.selected.push(item.key);
						tempSelectedArray.push(item.key);
						selected++;
					}
					if(item.children && item.children.length > 0) {
						recursiveSelectedInner(item);
					}
				});
			}
			recursiveSelectedInner(collection)
			return selected;
		}
		this.selected = tempSelectedArray;
		return selected;
	}

	checkParent(_item : any){
		let allSelected = true;
		if( _item.parent ){
			_item.parent.children.forEach( (item : any) => {
				if(!item.selected ){
					 allSelected = false;
				}
			});
			_item.parent.selected = allSelected;

			if( _item.parent.parent ){
				this.checkParent(_item.parent);
			}
		}
	}

	selectedMe(event: any, collection: any, isParent : boolean){
		let selected = false;
		this.showSubBusinessMenu = true;

		if (event && typeof event === 'object' && Object.prototype.hasOwnProperty.call(event, 'checkboxState')) {
			collection.selected = !!event.checkboxState;
		} else {
			collection.selected = !collection.selected;
		}
		selected = collection.selected;

		function setEm(_collection: any){
			if(_collection.children && _collection.children.length > 0){
				_collection.children.forEach( (item : any) => {
					item.selected = selected;
					if(item.children && item.children.length > 0){
						setEm(item);
					}
				});
			};
		}

		setEm(collection);
		this.checkParent(collection);
		this.getSelected();
		this.change();

		if(isParent){
			this.selectParentMe(collection);
		}
	}

	setMeSelection(me : any, value : boolean){
		//this.tempTotalMeSelected = 0;
		me.forEach( (me : any) => {
			this.tempTotalMeSelected++;
			me.selected = value;
			if(me.children){
				//this.totalMeSelected = value ? this.totalMeSelected + me.children.length : this.totalMeSelected - me.children.length;
				this.setMeSelection(me.children, value);
			};
		});
	};

	getAllMeCounts(me : any){
		let meCount = 0;
		//if(me.children){
		//	meCount += me.children.length;
		me.forEach( (me : any) => {
			meCount++;
			if(me.children){
				getMeCounts(me.children);
			}
		});

		function getMeCounts(me: any){
			me.children.forEach( (me : any) => {

				if(me.children){
					meCount += me.children.length;
					getMeCounts(me.children);
				};
			});
		};

		//}else{
		//	meCount += 1;
		//}
		return meCount;
	};

	meSelection(value: boolean){
		this.tempTotalMeSelected = 0;
		//this.totalMeSelected = 0;
		//this.totalMeSelected = this.getAllMeCounts(this.businessMeData);
		//this.setMeSelection(this.businessMeData, value);

		this.businessMeData.forEach( (me : any) => {
			//meCount++;
			//if(me.children){
				this.selectedMe(null, me, true);
			//}
		});

		if(value){
			this.totalMeSelected = this.tempTotalMeSelected;
			console.log(this.singleMeGrpCount);
		}else{
			this.totalMeSelected = 0;
		}
	}

	getTotalSelected(){
		this.totalSelected = this.getSelected();
	}

	selectedSubMe(subMe: any){
		console.log(subMe);
	}

	selectedSubChildMe(subChildMe: any){
		console.log(subChildMe);
	}

	onAvatarChevronClick(event: MouseEvent): void {
		event.stopPropagation();
		const container = (event.currentTarget as HTMLElement).closest('.avatar-container');
		const avatar = container?.querySelector('.ap-avatar') as HTMLElement;
		if (avatar) {
			avatar.click();
		}
	}

	isActive(route: string) {
		this.loadModules.emit(route);
		this.logoutMenu=false;
	}

	showDropdownMenuFun() {
		this.showDropdownMenu = !this.showDropdownMenu;
	}

	activeDropdownMenu(item: any) {
		this.dropdownMenuData.forEach(res => res.active = false);
		item.active = true;
		this.dropdownMenuActive = item.title;
		this.showDropdownMenuFun();
	}

	showLogoutMenu() {
		this.logoutMenu = !this.logoutMenu;
	}

	onAvatarSelect(event: any) {
		if (this.avatarComponent) {
			this.avatarComponent.showDropdown = false;
		}
		const value = event?.selected?.value || event?.value;
		if (value === 'logout') {
			this.singOut();
		} else if (value) {
			this.isActive(value);
		}
	}

	setTheme(item: 'white'|'black') {
		console.log("Swith theme api request");
		this.headerService.setTheme(this.baseURLs.admin,item).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res:any)=>{
			if(res?.callSuccess == "1" && res?.errorMessage == null){
				console.log("Theme was changed successfully.")
				this.isDarkTheme = !this.isDarkTheme;
				this.changeTheme.emit(item);
			}
		},
		err=>{
			console.log("Theme change failed");
		});
	}

	singOut() {
		this.logoutMenu = false;

		this.headerService
			.signout(this.baseURLs.api).pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(
				(response : any)=>{
          this.logoutUser.emit({});
				}
			)

	}

	showNavTogglerDiv() {
		this.navTogglerDiv = !this.navTogglerDiv;
	}

	activeNavToggler() {
		this.navTogglerDiv = false;
	}

	logoutMenuClose(e: any) {
		switch (e.which) {
		case 9:
			this.logoutMenu = false;
			break;
		}
	}

	navTogglerDivClose(e: any) {
		switch (e.which) {
		case 9:
			this.navTogglerDiv = false;
			break;
		}
	}

	favMenuClose(e: any) {
		switch (e.which) {
		case 9:
			this.showFavPanel = false;
			break;
		}
	}

	onKeyDropDownMenu(event: any) {
		switch (event.which) {
		case 9:
			this.showDropdownMenu = false;
			break;
		case 13:
			event.preventDefault();
			if (this.selectionCursor !== -1 && this.showDropdownMenu) {
			this.dropdownMenuData.forEach(res => res.active = false);
			this.dropdownMenuData[this.selectionCursor].active = true;
			this.dropdownMenuActive = this.dropdownMenuData[this.selectionCursor].title;
			this.showDropdownMenuFun();
			this.selectionCursor = -1;
			} else {
			this.showDropdownMenuFun();
			this.selectionCursor = -1;
			}
			break;
		case 38:
			event.preventDefault();
			if (!this.showDropdownMenu) {
			this.showDropdownMenuFun();
			}
			this.selectionCursor = this.selectionCursor < 1 ? 0 : this.selectionCursor - 1;
			break;
		case 40:
			event.preventDefault();
			if (!this.showDropdownMenu) {
			this.showDropdownMenuFun();
			}
			this.selectionCursor = this.selectionCursor > this.dropdownMenuData.length - 2 ? this.dropdownMenuData.length - 1 : this.selectionCursor + 1;
			break;
		}
	}

	//App Notifications related code
	activeSysMsgData : any = [];
	selectedSysMsgData : any = {};
	counter = 0;
	isMessageCountLoading : boolean = false;
	taskCount = 0;
	firstTime = true;
	reloadMessage = false;
	reloadTask = false;
	checkNotif = 0;

	getSystemNotification() {
		let data = {
			sso_id: this.USER_SETTINGS.user.sso_id,
			client_key: this.USER_SETTINGS.user.client_key,
			user_type: this.USER_SETTINGS.user.client.user_type_key
		}
		let notifData = {
			data : {},
			selectedSysMsgData : this.selectedSysMsgData,
			onlyNotifMsg : false,
			emptyNotifData : false
		};
		this.headerService.getSystemNotifByUser(this.baseURLs.admin, {data}).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
			if (data && data.callSuccess == 1) {
				this.activeSysMsgData = data.notif_list;
				if(data.notif_list && data.notif_list.length>0){
					this.selectedSysMsgData = data.notif_list[0];
					data.notif_list[0].notif_msg_body = safeJsonInput<any>(data.notif_list[0].notif_msg_body, null, 'header.parse4');
					notifData.data = data;
					notifData.selectedSysMsgData = this.selectedSysMsgData;
					notifData.onlyNotifMsg = true;
					this.gotNotifications.emit(notifData);
				}else{
					this.gotNotifications.emit(notifData);
				}
			}
		},
		error => {
			console.log(error);
			// Deciede whether to configure alert here on use the same in the AngularJS App.
			//AlertService.add('error', 'Global level ME seletions list failed, please contact support');
		},() => {
			console.log('Completed all tabs');
		});
	}

	/* to get the Unread Message count and Incompleted Tasks count  */
	getUnreadMessages() {
		if (this.counter > Number(this.SERVER_CONFIG.configSettings.max_no_of_failed_atempts)) {
			return;
		}

		if (this.isMessageCountLoading)
			return;
			this.isMessageCountLoading = true;

		this.headerService.getJSONObj(this.baseURLs.api,).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
			setTimeout(() => {
				this.isMessageCountLoading = false;
			}, 5000);

			if (data.unreadMessageCount === 'success') {
				let messageCount = data.totalUnreadMessageCount;
				let taskCount = Number(data.totalUnCompleteTaskCount);
				if (data == false && !this.isLocalHost()) {
					window.location.href = this.GENERAL_CONFIG.logout_idam_session;
				}
				if (this.firstTime) {
					this.messageCount = messageCount;
					this.taskCount = taskCount;
					this.firstTime = false;
				}

				if (this.messageCount !== messageCount) {
					this.reloadMessage = true;
					this.messageCount = messageCount;
				} else {
					this.reloadMessage = false;
				}
				/* starts added on 7/25/2019 */
				if(this.taskCount !== taskCount){
					this.reloadTask = true;
					this.taskCount = taskCount;
				}else{
					this.reloadTask = false;
				}
				/* ends here*/
			} else {
				this.counter++;
			}
		},
		error => {
			console.log(error);
		},() => {
			console.log('Completed all tabs');
		});
	}

		private isLocalHost(): boolean {
			return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
		}

	notifCong(){
		if(this.checkNotif == 1){
			let data = {
				sys_notif_key : this.selectedSysMsgData.notif_msg_key,
				sso_id: this.USER_SETTINGS.user.sso_id,
				client_key: this.USER_SETTINGS.user.client_key
			}
			let notifData = {
				data : {},
				selectedSysMsgData : {},
				onlyNotifMsg : false,
				emptyNotifData : true
			};
			this.headerService.saveSystemDontShowMsg(this.baseURLs.admin, data).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
				if(data && data.callSuccess == 1){
					if(this.activeSysMsgData && this.activeSysMsgData.length > 1) {
						//Remove the notifications only active list is morethan one and sets the first notification from the active list, otherwise will remove the notification..
						this.activeSysMsgData.forEach( (item : any) => {
							if(item && item.notif_msg_key == this.selectedSysMsgData.notif_msg_key) {
								this.activeSysMsgData.splice(item, 1);
							}
						});

						this.selectedSysMsgData = this.activeSysMsgData[0];
					} else {
						this.activeSysMsgData = [];
						this.gotNotifications.emit(notifData);
					}
				}
				this.checkNotif = 0;
			})
		}
	}

	cancelNotifModal(){
		let notifData = {
			data : {},
			selectedSysMsgData : {},
			onlyNotifMsg : false,
			emptyNotifData : true
		};
		this.gotNotifications.emit(notifData);
	}

	closeBusinessDropdown(event:any){
		this.showBusinessMenu= false;
	}

	loadClickedScreen(clickedScreen:any){
		if( Object.keys(clickedScreen).indexOf('SCREEN_NAME') < 0 && Object.keys(clickedScreen).indexOf('screenKey') < 0 ){
			this.allScreens.forEach((screen) => {
				if(screen.SCREEN_NAME == clickedScreen.name){
					this.activeScreensService.markOpenSelectedScreen(screen);
				this.loadScreen.emit({activity_key:screen.ACTIVITY_KEY, screen_key:screen.SCREEN_KEY});
				}
			});
		}else{
			let key = clickedScreen?.screenKey || clickedScreen?.SCREEN_KEY;
			this.allScreens.forEach(screen => {
				if(screen.SCREEN_KEY == key){
					this.activeScreensService.markOpenSelectedScreen(screen);
					this.loadScreen.emit({activity_key:screen.ACTIVITY_KEY, screen_key:screen.SCREEN_KEY});
				}
			});
		}
	  }

}
